import { OfferResponse } from 'src/app/models/apis/offer.model';
import { PreauthorizedOffer } from 'src/app/models/state/preauthorized-offer.model';
import {
	ApplicantName,
	ApplicantType,
} from 'src/app/models/state/pre-application.model';

export function mapFromOfferResponse(
	offer: OfferResponse | null,
	options: { productCode: string; memberId: number; memberName?: string }
): PreauthorizedOffer {
	const applicantName: ApplicantName = {
		name: options.memberName ?? '',
		firstSurname: '',
		secondSurname: '',
	};
	return {
		offerName: applicantName,
		offerPersonId: options.memberId,
		offerPersonType: ApplicantType.MEMBER,
		preauthorizedMount: offer?.monto ?? 0,
		selectedAmount: 0,
		selectedTerm: offer?.plazo ?? 0,
		folioDigital: options.productCode,
		productCobisId: offer?.codigo_producto ?? options.productCode ?? '',
		applicantPhone: '',
		isApplicantAMember: true,
		rate: offer?.tasa ?? 0,
		term: offer?.plazo ?? 0,
	};
}
